import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import ModalComponent from "../../../components/Modal";
import CustomDropdown from "../../../components/CustomDropdown";
import TextInput from "../../../components/TextInput";
import { useDispatch } from "react-redux";
import { requestDocumentUpload } from "../../../Redux/EmployeeStatusState/empStatusActionCreator";
import moment from "moment";
import { useParams } from "react-router-dom";
import LOCAL_KEYS, {
  parseLocalStorageJSON,
} from "../../../helpers/Localstorage";
import MuiDatePicker from "../../../components/MuiDatePicker";
import { documentValidationSchema } from "../../../components/Helpers";


const DocumentModal = ({
  onClose,
  show,
  title,
  initialValues,
  documentsList,
  submitForm,
}) => {
  const dispatch = useDispatch();
  const [list, setList] = useState([]);
  const { id } = useParams();
  const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
  const [isOthersSelected, setIsOthersSelected] = useState(false);

  const handleSubmit = (values) => {
    submitForm(values);
    handleClose();
  };

  const handleClose = () => {
    setIsOthersSelected(false);
    onClose();
  };

  useEffect(() => {
    setList(() => {
      return documentsList.map((item) => {
        return {
          label: item,
          value: item,
        };
      });
    });
  }, [documentsList]);

  return (
    <ModalComponent show={show} onClose={handleClose} title={title}>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
        validationSchema={documentValidationSchema}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          resetForm,
        }) => (
          <Form className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 py-3">
            {/* Document Type */}
            <div className="space-y-2">
              <CustomDropdown
                value={
                  list?.find((user) => user.value === values?.documentType) ||
                  null
                }
                name="documentType"
                handleChange={(selectedOption) => {
                  setFieldValue("documentType", selectedOption.value);
                  setIsOthersSelected(selectedOption.value === "OTHER");
                }}
                customClasses="w-full text-left"
                placeholder="Select Type of Document"
                options={list}
                handleGetOptionValue={(option) => option.value}
                handleGetOptionName={(option) => option.label}
              />
              {errors.documentType && touched.documentType && (
                <div className="text-red-500 text-sm text-left">
                  {" "}
                  {errors.documentType}{" "}
                </div>
              )}

              {isOthersSelected && (
                <div className="space-y-2 pt-3">
                  <TextInput
                    type="text"
                    name="others"
                    handleChange={handleChange}
                    value={values.others}
                    placeholder="Enter Document Type"
                    disabled={!isOthersSelected}
                    classes="w-full"
                  />
                  {errors.others && touched.others && (
                    <div className="text-red-500 text-sm text-left">{errors.others}</div>
                  )}
                </div>
              )}
            </div>

            {/* Upload Document */}
            <div className="space-y-2">
              <input
                type="file"
                id="file"
                name="file"
                onChange={(event) => {
                  const file = event.target.files[0];
                  setFieldValue("file", file);
                }}
                className="block w-full px-3 py-1 border border-gray-300 h-[2.5rem] rounded-md focus:ring-1 focus:ring-primary"
              />
              {errors.file && touched.file && (
                <div className="text-red-500 text-sm text-left">{errors.file}</div>
              )}
            </div>
            <div className="space-y-2 relative overflow-visible">
               
                <MuiDatePicker
                label="Issue Date"
                value={values?.issueDate ? moment(values.issueDate) : null}
                onChange={(date) => {
                  if (date) {
                    setFieldValue("issueDate", date.format("YYYY-MM-DD"));
                  }
                }}
                maxDate={moment()} // Disable future dates by setting max date to today
                minDate={null}
              />

              {/* </div> */}
              {errors.issueDate && touched.issueDate && (
                <div className="text-red-500 text-sm text-left">{errors.issueDate}</div>
              )}
            </div>

            <div className="space-y-2 relative overflow-visible">
            <MuiDatePicker
                label="Expiry Date"
                value={values?.expiryDate ? moment(values.expiryDate) : null}
                onChange={(date) => {
                  if (date) {
                    setFieldValue("expiryDate", date.format("YYYY-MM-DD"));
                  }
                }}
                minDate={moment().startOf('day')} // Set minimum date to today to prevent past dates
                maxDate={null} 
                // minDate={moment(values?.issueDate) || null}
              />
              {errors.expiryDate && touched.expiryDate && (
                <div className="text-red-500 text-sm text-left">{errors.expiryDate}</div>
              )}
            </div>

            <div className="col-span-1 sm:col-span-2 flex flex-col sm:flex-row justify-end gap-2 mt-4">
            <button
              type="button"
              className="bg-gray-300 text-black h-10 py-1 px-4 w-full sm:w-40 rounded-lg hover:bg-gray-400"
              onClick={() => {
                resetForm();
                setIsOthersSelected(false);
                handleClose();
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-primary text-white h-10 py-1 px-4 w-full sm:w-40 rounded-lg hover:bg-primaryDark"
            >
              Submit
            </button>
          </div>
          </Form>

        )}
      </Formik>
    </ModalComponent>
  );
};

export default DocumentModal;
